const highlightVideos = [
  { id: '4GcfFR6J2ew', title: 'Golden Tree Events Highlight' },
  { id: 'mAOXnMn41tc', title: 'Award Ceremony Highlights' },
];

export const HighlightVideosSection = () => {
  return (
    <section data-testid="highlight-videos-section" className="py-24 bg-[#0a0a0a]">
      <div className="w-full px-4 sm:px-8 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="font-google-sans text-[#D4AF37] text-xs tracking-[0.3em] uppercase mb-4">Watch Now</p>
          <h2 className="font-montserrat text-4xl sm:text-5xl text-white font-bold">
            Highlight <span className="gradient-gold">Videos</span>
          </h2>
        </div>

        {/* 2 Column Video Grid - Embedded Videos */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {highlightVideos.map((video, index) => (
            <div
              key={video.id}
              data-testid={`highlight-video-${index}`}
              className="relative aspect-video bg-black rounded-xl overflow-hidden"
            >
              <iframe
                src={`https://www.youtube.com/embed/${video.id}?rel=0`}
                title={video.title}
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
